// extracted by mini-css-extract-plugin
module.exports = {"root":"button-group_root__cdq0u","direction-horizontal":"button-group_direction-horizontal__4O6wK","direction-vertical":"button-group_direction-vertical___Iqh6"};